import React, { useEffect, useState } from "react";
import { createStyles, IconButton, TableCell, TableRow, Theme, withStyles } from "@material-ui/core";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { Product } from "../../../model/Product";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";

type EventType = { id: string; name: string };

type Props = {
    id: string | number;
    event: EventType;
    products?: Product[];
    productFilter?: string;

    onRequestDuplicateProduct: (product: Product) => void;
    onRequestEditProduct: (product: Product) => void;
    onRequestDeleteProduct: (product: Product) => void;
};

const getFilteredProducts = (event: EventType, sourceProducts?: Product[], filter?: string): Product[] => {
    if (!sourceProducts || sourceProducts.length === 0) {
        return [];
    }

    if (!filter) {
        return sourceProducts.sort((a, b) => a.name.localeCompare(b.name, "sv"));
    }

    const upperEventName = event.name.toUpperCase();
    const upperFilter = filter?.toUpperCase() ?? "";

    return sourceProducts
        .filter(x => upperEventName.indexOf(upperFilter) > -1 || x.name.toUpperCase().indexOf(upperFilter) > -1)
        .sort((a, b) => a.name.localeCompare(b.name, "sv"));
};

const EventRow = (props: Props) => {
    const [expanded, setExpanded] = useState(true);
    const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);

    useEffect(() => {
        setFilteredProducts(getFilteredProducts(props.event, props.products, props.productFilter));
    }, [props.event, props.products, props.productFilter]);

    const handleDuplicateClick = (product: Product) => () => {
        props.onRequestDuplicateProduct(product);
    };

    const handleEditClick = (product: Product) => () => {
        props.onRequestEditProduct(product);
    };

    const handleDeleteClick = (product: Product) => () => {
        props.onRequestDeleteProduct(product);
    };

    const render = () => {
        const { id, event } = props;

        if (!event || !filteredProducts || filteredProducts.length === 0) {
            return null;
        }

        const tableRows: JSX.Element[] = [];
        const borderBottom = expanded ? "" : "1px solid #ccc";

        // Header row
        tableRows.push(
            <TableRow key={id}>
                <StyledTableCell
                    style={{ backgroundColor: "#ddd", borderBottom: borderBottom }}
                    colSpan={3}
                >
                    {event.name || "Övriga"}
                </StyledTableCell>
                <StyledTableCell align="right"
                    style={{ backgroundColor: "#ddd", borderBottom: borderBottom }}

                >
                    <IconButton color="default" size="small"
                        onClick={() => {
                            setExpanded(!expanded)
                        }}

                    >
                        {expanded ? (
                            <KeyboardArrowUp />
                        ) : (
                            <KeyboardArrowDown />
                        )}
                    </IconButton>
                </StyledTableCell>
            </TableRow>
        );

        if (expanded) {
            filteredProducts.forEach((product, idx) => {
                tableRows.push(<TableRow key={id + "_" + idx}>
                    <StyledTableCell style={{ cursor: "pointer" }} onClick={handleEditClick(product)}>{product.name}</StyledTableCell>
                    <StyledTableCell>{event.name}</StyledTableCell>
                    <StyledTableCell>{product.variants ? product.variants.length : 0}</StyledTableCell>
                    <StyledTableCell align="right">
                        <IconButton color="default" size="small"
                            onClick={handleDuplicateClick(product)}
                        >
                            <FileCopyIcon fontSize="medium" />
                        </IconButton>
                        <IconButton color="default" size="small"
                            onClick={handleEditClick(product)}
                        >
                            <EditIcon fontSize="medium" />
                        </IconButton>
                        <IconButton color="default" size="small"
                            onClick={handleDeleteClick(product)}
                        >
                            <DeleteIcon fontSize="medium" />
                        </IconButton>
                    </StyledTableCell>
                </TableRow>);
            });
        }

        return (<>{tableRows}</>);
    };

    return render();
}

const tableHeadStyles = ({ palette, spacing }: Theme) => createStyles({
    head: {
        background: palette.primary.main,
        color: palette.primary.contrastText,
    }
});

const StyledTableCell = withStyles(tableHeadStyles)(TableCell);

export default EventRow;
